module.exports = __webpack_public_path__ + "static/img/amore-disteady.c5341c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/amore-disteady.jpg
// module id = pw3u
// module chunks = 0